module.exports = "<p>\n  logout works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/logout/logout.component.html
// module id = ./client/app/logout/logout.component.html
// module chunks = main